// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E1_c","icon":"styles_icon__2lca0"};